import { CheckCircle, X, Buildings, Prohibit, MinusCircle } from "@phosphor-icons/react";

/**
 * BanquePill — pill 1-clic cyclique.
 *
 * Cycle des statuts (tap successifs) :
 *   neutral → retained → rejected_us → rejected_them → neutral
 *
 * - neutral       : sollicitée, en attente (grisée)
 * - retained      : retenue (verte — banque choisie)
 * - rejected_us   : non retenue (slate — on a écarté)
 * - rejected_them : refus (rouge — la banque a refusé)
 */
const NEXT_STATUS = {
  neutral: "retained",
  retained: "rejected_us",
  rejected_us: "rejected_them",
  rejected_them: "neutral",
};

const STATUS_STYLE = {
  neutral:       { bg: "var(--cf-primary-soft)", text: "var(--cf-primary-hover)", border: "transparent", label: "Sollicitée",   Icon: Buildings },
  retained:      { bg: "var(--cf-success-soft)", text: "var(--cf-success-text)", border: "transparent", label: "Retenue",      Icon: CheckCircle },
  rejected_us:   { bg: "var(--cf-bg-2)", text: "var(--cf-neutral-text)", border: "transparent", label: "Non retenue",  Icon: MinusCircle },
  rejected_them: { bg: "var(--cf-danger-soft)", text: "var(--cf-danger-text)", border: "transparent", label: "Refus",        Icon: Prohibit },
};

export default function BanquePill({ name, status = "neutral", onChange, onRemove }) {
  const s = STATUS_STYLE[status] || STATUS_STYLE.neutral;
  const Icon = s.Icon;

  const cycle = () => {
    const next = NEXT_STATUS[status] || "retained";
    onChange?.(next);
  };

  return (
    <span
      className="inline-flex items-center gap-1.5 px-2.5 py-1.5 rounded-full text-[12px] font-bold transition-all"
      style={{ background: s.bg, color: s.text }}
      data-testid={`banque-pill-${name}`}
    >
      <button
        type="button"
        onClick={cycle}
        className="inline-flex items-center gap-1.5 hover:brightness-95"
        title={`${s.label} · cliquer pour changer`}
        data-testid={`banque-cycle-${name}`}
      >
        <Icon size={12} weight="fill" />
        <span className="font-extrabold">{name}</span>
        <span className="text-[10px] font-bold opacity-70 uppercase tracking-wider">{s.label}</span>
      </button>
      <button
        type="button"
        onClick={onRemove}
        className="ml-0.5 opacity-50 hover:opacity-100"
        title="Retirer la banque"
        data-testid={`banque-remove-${name}`}
      >
        <X size={10} weight="bold" />
      </button>
    </span>
  );
}
